import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const DeliveryMediumIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    height={56}
    width={56}
    fill="none"
    viewBox="0 0 56 56"
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2172 15.5522C17.5892 15.1977 18.0833 15 18.5971 15H24.2686C24.7707 15 25.2545 15.1889 25.6238 15.5292L29.5335 19.1318L33.0495 20.4448C34.2224 20.8828 35 22.0032 35 23.2552V24.4143C35 25.2901 34.2901 26 33.4143 26H31.9578C31.9856 26.18 32 26.3643 32 26.5517V27H30V26.5517C30 25.6753 29.3092 25 28.5 25C27.6908 25 27 25.6753 27 26.5517V27H25V26.5517C25 26.3643 25.0144 26.18 25.0422 26H19.9578C19.9856 26.18 20 26.3643 20 26.5517V27H18V26.5517C18 25.6753 17.3092 25 16.5 25C15.6908 25 15 25.6753 15 26.5517V27H13V26.5517C13 26.3643 13.0144 26.18 13.0422 26H10.998C9.8931 26 8.99751 25.104 8.99805 23.999L8.99902 21.9985C8.99983 20.3423 10.3427 19 11.999 19H13.5998L17.2172 15.5522ZM26.0653 24C26.6924 23.3827 27.5481 23 28.5 23C29.4519 23 30.3076 23.3827 30.9347 24H33V23.2552C33 22.8379 32.7408 22.4644 32.3498 22.3184L28.8338 21.0054C28.5913 20.9148 28.3686 20.778 28.1782 20.6026L24.2686 17L18.5971 17L14.9796 20.4478C14.6077 20.8023 14.1136 21 13.5998 21H11.999C11.4469 21 10.9993 21.4474 10.999 21.9995L10.998 24H14.0653C14.6924 23.3827 15.5481 23 16.5 23C17.4519 23 18.3076 23.3827 18.9347 24H26.0653Z"
      fill="#00AED9"
    />
    <path
      d="M42.5 20.9492H48C52.1791 20.9492 52.8681 28.3769 52.9791 33.0029C53.0057 34.1072 52.1046 35 51 35H47.7329M3 29.0095L28.8724 35.9657C28.9571 35.9885 29.0444 36 29.1321 36H42V19H40.82C40.3432 19 39.9328 19.3366 39.8394 19.8041L38.1611 28.2054C38.0677 28.6729 37.6572 29.0095 37.1804 29.0095H3Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="45" cy="36" r="3" stroke="#00619E" strokeWidth="2" />
    <circle cx="17" cy="36" r="3" stroke="#00619E" strokeWidth="2" />
  </svg>
));

export default DeliveryMediumIcon;
